<button class="menu-button" [class.is-idp]="siteType === 'idp'" [class.is-slim]="barType === 'slim'">
  <div class="icon" [class.open]="isOpen">
    @for (i of 3 | times; track $index) {
      <span class="bar"></span>
    }
  </div>
</button>
